import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-app-blocking-spinner',
  templateUrl: './app-blocking-spinner.component.html',
  styleUrl: './app-blocking-spinner.component.css'
})
export class AppBlockingSpinnerComponent {

  @Input() isLoading: boolean = false;
  @Input() spinnerMsg: string = "";
  
    //private subscription: Subscription;
    constructor(
     // private loaderService: LoaderService
    ) {
  
    }
  
    ngOnInit(): void {
      
    }

}

